import React from 'react';
const steps = [{
  number: '01',
  title: 'Add your prompts',
  description: 'Enter the questions your customers are asking AI systems – organized by topic, intent, or product.'
}, {
  number: '02',
  title: 'We track daily',
  description: 'Andoe runs your prompts across ChatGPT and Google every day and records how your brand appears.'
}, {
  number: '03',
  title: 'See your visibility',
  description: 'Monitor your prompts and competitors. We show what to optimize next with our recommendation engine.'
}];
export function HowItWorksSection() {
  return <section className="w-full bg-[#FAF9F7] py-24 px-4 border-t border-[#E8E6E3]" data-id="element-90">
      <div className="max-w-5xl mx-auto" data-id="element-91">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-92">
          <h2 className="text-3xl md:text-[2.75rem] font-medium tracking-tight text-[#0F0F0F] leading-[1.1] mb-5" data-id="element-93">
            How it works
          </h2>
          <p className="text-lg text-[#5C5C5C] leading-relaxed" data-id="element-94">
            Three steps to track how AI represents your brand.
          </p>
        </div>

        {/* Steps — minimal, typography-driven */}
        <div className="grid grid-cols-1 md:grid-cols-3" data-id="element-95">
          {steps.map((step, index) => <div key={step.number} className={`py-8 md:py-0 md:px-10 ${index !== 0 ? 'border-t md:border-t-0 md:border-l border-[#E8E6E3]' : ''} ${index === 0 ? 'md:pl-0' : ''} ${index === steps.length - 1 ? 'md:pr-0' : ''}`} data-id="element-96">
              <span className="block text-[3.5rem] md:text-[4rem] font-semibold leading-none text-[#E8E6E3] tracking-tight select-none mb-6" data-id="element-97">
                {step.number}
              </span>
              <h3 className="text-lg font-medium text-[#0F0F0F] tracking-tight mb-3" data-id="element-98">
                {step.title}
              </h3>
              <p className="text-[15px] text-[#5C5C5C] leading-relaxed" data-id="element-99">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}